export default function Hero() {
  return (
    <section id="hero" className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20warm%20gradient%20background%20with%20soft%20overlapping%20organic%20shapes%20in%20coral%20orange%20and%20cream%20tones%2C%20subtle%20texture%20pattern%2C%20modern%20minimalist%20aesthetic%2C%20gentle%20flowing%20composition%20with%20negative%20space%2C%20warm%20inviting%20atmosphere%20without%20any%20text%20or%20characters%2C%20editorial%20design%20style%20with%20soft%20light%20gradients&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 lg:pt-0">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-xs font-medium text-primary-600">每日更新 · 海量资源</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-heading text-foreground-950 leading-tight">
              爱漫画 · 免费在线看全集
            </h1>

            <p className="mt-2 md:mt-3 text-base md:text-lg text-foreground-600 font-heading">
              国漫日漫韩漫，下拉畅读，随时追更
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              非常爱漫画汇聚全网热门漫画资源，涵盖国漫、日漫、韩漫等全品类作品。支持下拉式阅读模式，翻页流畅不卡顿，手机电脑随时随地免费畅读。每日同步更新，追更不等待，热门新番第一时间上线，漫画大全尽在爱漫画。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6 text-sm text-foreground-500">
              <div className="flex items-center gap-1.5">
                <i className="ri-book-open-line text-primary-500"></i>
                <span>10万+ 漫画资源</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-flashlight-line text-accent-500"></i>
                <span>每日同步更新</span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-smartphone-line text-primary-500"></i>
                <span>下拉式畅读体验</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-compass-3-line"></i>
                开始探索
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3 border-2 border-foreground-200 text-foreground-700 font-semibold rounded-full hover:border-primary-400 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer text-sm"
              >
                <i className="ri-fire-line"></i>
                热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[360px] sm:w-[320px] sm:h-[400px] md:w-[380px] md:h-[480px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20a%20young%20person%20reading%20a%20comic%20book%20with%20excitement%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20modern%20flat%20illustration%20style%20with%20soft%20shadows%2C%20cozy%20reading%20atmosphere%2C%20surrounded%20by%20floating%20comic%20panels%20and%20speech%20bubbles%2C%20clean%20minimalist%20composition%2C%20editorial%20quality&width=800&height=1000&seq=hero-visual-2026&orientation=portrait"
                alt="爱漫画阅读体验"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-4 left-4 right-4 bg-background-50/90 backdrop-blur-sm rounded-xl p-3 flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className="ri-thumb-up-line text-primary-500 text-lg"></i>
                </div>
                <div>
                  <div className="text-xs font-semibold text-foreground-900">读者好评</div>
                  <div className="text-xs text-foreground-500">98% 用户推荐</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}